/**
 * GAT Custom JS
 * Force-hide recommendations briefly so the cart appears first,
 * then releases them for a proper sequential animation.
 */

(function () {
  const observer = new MutationObserver(() => {
    const cart = document.querySelector('cart-notification');
    const rec = document.querySelector('minicart-recommendations-beside');

    if (!cart || !rec) return;

    const isOpen = cart.classList.contains('open') || cart.classList.contains('open_drawer');

    if (isOpen) {
      // Force hide recommendations immediately
      rec.classList.add('gat-force-hidden');
      rec.classList.remove('open');

      // Release them after the cart has started animating
      setTimeout(() => {
        const currentRec = document.querySelector('minicart-recommendations-beside');
        if (currentRec) {
          currentRec.classList.remove('gat-force-hidden');
          currentRec.classList.add('open');
        }
      }, 380);
    } else {
      // Cart closed
      rec.classList.remove('gat-force-hidden');
      rec.classList.remove('open');
    }
  });

  function start() {
    const cart = document.querySelector('cart-notification');
    if (cart) {
      observer.observe(cart, { attributes: true, attributeFilter: ['class'] });
    } else {
      setTimeout(start, 400);
    }
  }

  start();
})();  